import styled from "styled-components";
import {Box, Button, FormHelperText, Grid, TextField, Typography} from "@mui/material";
import React, {useState} from "react";
import Logo from "../../../../../../picture/Logo.png";
import {logout, modifyPhone, modifyPhoneSMS} from "../../../../../../api";


const FormHelperTextsRED = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
  display: flex;
  align-items: center;
`;

const FormHelperTextsBLUE = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #0f27d9 !important;
`;
export default function PhoneModalComponent(props){

    const { data, sectionType }=props


    const [phone, setPhone] = useState("");
    const [PhoneMessage, setPhoneMessage] = useState("")


    const onChangePhone = (getNumber) => {
        const currentPhone = getNumber;
        setPhone(currentPhone);
        const phoneRegExp = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;

        if (!phoneRegExp.test(currentPhone)) {
            setPhoneMessage('올바른 핸드폰번호를 입력해주세요. (" - " <= 하이픈 필수입니다.)');
        } else {
            setPhoneMessage("");
        }
    };
    const addHyphen = (e) => {
        const currentNumber = e.currentTarget.value;
        setPhone(currentNumber);
        if (currentNumber.length === 3 || currentNumber.length === 8) {
            setPhone(currentNumber + "-");
            onChangePhone(currentNumber + "-");
        } else {
            onChangePhone(currentNumber);
        }
    };

    const [sign, setSign] =useState("")
    const [isSign,setIsSign]= useState(false)
    const sendSMSHandler =(e)=>{
        e.preventDefault()
        let newData = {
            userId:data.userId,
            phone:phone,
            phoneNum:data.phone,
            phoneSubject: '고객 전화번호 변경'
        }
        modifyPhoneSMS(newData)
            .then((res)=>{
                setSign(res.data)
                alert(res.data)
            })
            .catch(function (err){
                alert(err.response.data)
            })
    }
    const [signNum, setSignNum] = useState("");

    const onChangeSignHandler = (e) => {
        setSignNum(e.target.value);
        setIsSign(true)
    }


    const [res,setRes] = useState('')
    const [isLogout,setIsLogout] = useState(false)
    const [logoutUser,setLogoutUser] = useState({})

    const onSubmitHandler = (e) => {
        e.preventDefault();
        let newData = {
            userId: data.userId,
            changePhoneNum: phone,
            phone: data.phone,
            authNum: signNum
        }
        modifyPhone(newData)
            .then((res) => {
                setRes(res.data)
                alert('수정 완료.')
                window.location.replace('/userInfo')
            })
            .catch(e => {
                alert(e.response.data)
            })
    }







    return(
        <>
            {sectionType === 'mobile' ? (
                <>
                    <div style={{height: 350, width: '100%'}}>
                        <Box
                            component="form"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                borderRadius: '1rem',
                            }}
                        ><br/>
                            <img alt="No Images" src={Logo} style={{width:270,height:80,paddingRight:30}}/>

                            <Typography component="h4" variant="h0">
                                전화번호 수정
                            </Typography><br/><br/>

                                    <TextField
                                        required
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="phone"
                                        label='기존 전화번호'
                                        defaultValue={data.phone}
                                        disabled
                                    /><br/>
                                    <div style={{display:'flex'}}>
                                        <TextField
                                            autoFocus
                                            required
                                            sx={{width:220}}
                                            size="small"
                                            type="text"
                                            name="phone"
                                            label='변경하실 전화번호("-" 하이픈 자동생성)'
                                            value={phone}
                                            onChange={addHyphen}
                                            error={PhoneMessage === '올바른 핸드폰번호를 입력해주세요. (" - " <= 하이픈 필수입니다.)' || false}
                                        />

                                        <Button
                                            value={sign}
                                            variant="contained"
                                            type="submit"
                                            size="small"
                                            sx={{
                                                marginLeft:1,
                                                width:'88px',
                                                height:'40px',
                                                border:3,
                                                "&.MuiButton-root:hover":{
                                                    color:'#008DDC',
                                                    backgroundColor:'#c7ebff',
                                                    borderColor:'#008DDC'
                                                }
                                            }}
                                            onClick={sendSMSHandler}
                                            disabled={phone.length<13}
                                        >
                                            인증받기
                                        </Button>
                                    </div>
                                    <FormHelperTextsRED>{PhoneMessage}</FormHelperTextsRED>
                             <br/>

                                    <TextField
                                        fullWidth
                                        label="인증번호"
                                        size="small"
                                        value={signNum}
                                        type="text"
                                        onChange={onChangeSignHandler}
                                    />


                                    <FormHelperTextsBLUE>{sign}</FormHelperTextsBLUE>
                            <br/>

                                    <Button
                                        onClick={onSubmitHandler}
                                        variant="contained"
                                        type="submit"
                                        size="small"
                                        fullWidth
                                        sx={{
                                            marginTop: 1,
                                            height: '45px',
                                            border: 3,
                                            "&.MuiButton-root:hover": {
                                                color: '#008DDC',
                                                backgroundColor: '#c7ebff',
                                                borderColor: '#008DDC'
                                            }
                                        }}
                                        disabled={phone.length < 13 || isSign === false}
                                    >
                                        수정하기
                                    </Button>

                        </Box>
                    </div>
                </>
            ):(
                <>
                    <div style={{height: 520, width: '100%'}}>
                        <Box
                            component="form"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundColor: 'white',
                                height: '500px',
                                width: '530px',
                                borderRadius: '1rem',
                            }}
                        ><br/>
                            <img alt="No Images" src={Logo} style={{width:350,height:110,paddingRight:30}}/><br/>

                            <Typography component="h4" variant="h0">
                                전화번호 수정
                            </Typography><br/><br/>
                            <Grid container spacing={1}>
                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        required
                                        fullWidth
                                        type="text"
                                        name="phone"
                                        label='기존 전화번호'
                                        defaultValue={data.phone}
                                        disabled
                                    /><br/><br/>
                                </Grid>
                                <br/>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={7.5}>
                                    <TextField
                                        autoFocus
                                        required
                                        fullWidth
                                        type="text"
                                        name="phone"
                                        label='변경하실 전화번호("-" 하이픈 자동생성)'
                                        value={phone}
                                        onChange={addHyphen}
                                        error={PhoneMessage === '올바른 핸드폰번호를 입력해주세요. (" - " <= 하이픈 필수입니다.)' || false}
                                    /><br/>
                                </Grid>
                                <Grid item xs={2}>
                                    <Button
                                        value={sign}
                                        variant="contained"
                                        type="submit"
                                        size="medium"
                                        sx={{
                                            marginTop:0,
                                            width:'105px',
                                            height:'55px',
                                            border:3,
                                            "&.MuiButton-root:hover":{
                                                color:'#008DDC',
                                                backgroundColor:'#c7ebff',
                                                borderColor:'#008DDC'
                                            }
                                        }}
                                        onClick={sendSMSHandler}
                                        disabled={phone.length<13}
                                    >
                                        인증받기
                                    </Button><br/>
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <FormHelperTextsRED>{PhoneMessage}</FormHelperTextsRED>
                                </Grid>
                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <TextField
                                        fullWidth
                                        label="인증번호"
                                        value={signNum}
                                        type="text"
                                        onChange={onChangeSignHandler}
                                    />
                                </Grid>
                                <Grid item xs={1}/>
                                <Grid item xs={1}/>
                                <Grid item xs={10}>

                                    <FormHelperTextsBLUE>{sign}</FormHelperTextsBLUE>
                                </Grid>

                                <Grid item xs={1}/>

                                <Grid item xs={1}/>
                                <Grid item xs={10}>
                                    <Button
                                        onClick={onSubmitHandler}
                                        variant="contained"
                                        type="submit"
                                        size="medium"
                                        fullWidth
                                        sx={{
                                            marginTop: 1,
                                            height: '45px',
                                            border: 3,
                                            "&.MuiButton-root:hover": {
                                                color: '#008DDC',
                                                backgroundColor: '#c7ebff',
                                                borderColor: '#008DDC'
                                            }
                                        }}
                                        disabled={phone.length < 13 || isSign === false}
                                    >
                                        수정하기
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </div>
                </>
            )}

        </>
    )
}